import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-numero-inicial',
  templateUrl: './text-numero-inicial.component.html',
  styleUrls: ['./text-numero-inicial.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class TextNumeroInicialComponent implements OnInit {

  @Input() formGroup: FormGroup;

  constructor() { }

  ngOnInit() {
  }

}
